module.exports = __webpack_public_path__ + "img/icon-answer-hand.ea6f6a66.svg";